// lot store inner constants
export const GET_SELECTEDCN = 'SelectedCNGet';
export const GET_AUTOSELECTCN = 'AutoSelectCNGet';
export const GET_SELECTEDTAB = 'SelectedTabGet';
export const GET_SELECTEDCNSEAL = 'SelectedCNSealGet';
export const GET_AUTOSELECTCNSEAL = 'AutoSelectCNSealGet';
export const GET_SELECTEDTABSEAL = 'SelectedTabSealGet';
export const GET_CLOUD = 'getCloudProvider';
export const GET_CLOUD_SEAL = 'getSealCloudProvider';
export const GET_CLOUD_PROVIDER = 'getCloudProviderData';
export const GET_CLOUD_PROVIDER_SEAL = 'getSealCloudProviderData';
export const GET_USER_CERT = 'getUserCertificates';
export const GET_SHOWALLDEVICES = 'getShowAllDevices';
export const GET_SHOWALLDEVICES_SEAL = 'getShowAllDevicesSeal';
export const GET_SELECTEDDEVICE = 'getSelectedDevice';
export const GET_SELECTEDDEVICE_SEAL = 'getSelectedDeviceSeal';

export const MUT_SELECTEDCN = 'setSelectedCN';
export const MUT_AUTOSELECTCN = 'setAutoSelectCN';
export const MUT_SELECTEDTAB = 'setSelectedTab';
export const MUT_SELECTEDCNSEAL = 'setSelectedCNSeal';
export const MUT_AUTOSELECTCNSEAL = 'setAutoSelectCNSeal';
export const MUT_SELECTEDTABSEAL = 'setSelectedTabSeal';
export const MUT_CLOUD = 'setCloudProvider';
export const MUT_CLOUD_SEAL = 'setSealCloudProvider';
export const MUT_CLOUD_PROVIDER = 'setCloudProviderData';
export const MUT_CLOUD_PROVIDER_SEAL = 'setSealCloudProviderData';
export const MUT_ADD_USER_CERT = 'addUserCertificate';
export const MUT_DEL_USER_CERT = 'delUserCertificate';
export const MUT_CLEAR_USER_CERTS = 'clearUserCertificates';
export const MUT_SHOWALLDEVICES = 'setShowAllDevices';
export const MUT_SHOWALLDEVICES_SEAL = 'setShowAllDevicesSeal';
export const MUT_SELECTEDDEVICE = 'setSelectedDevice';
export const MUT_SELECTEDDEVICE_SEAL = 'setSelectedDeviceSeal';
